(function () {
  function setText(el, value) {
    if (!el) return;
    el.textContent = value || '';
    el.hidden = !value;
  }

  document.addEventListener('click', function (event) {
    const pill = event.target.closest('[data-variant-pill]');
    if (!pill) return;

    event.preventDefault();
    if (pill.classList.contains('is-soldout')) return;

    const wrapper = pill.closest('[card-variant-pills]');
    const card = pill.closest('product-card');
    if (!wrapper) return;

    wrapper.querySelectorAll('[data-variant-pill]').forEach(function (item) {
      item.classList.remove('is-selected');
      item.setAttribute('aria-pressed', 'false');
    });
    pill.classList.add('is-selected');
    pill.setAttribute('aria-pressed', 'true');

    // form ka hidden variant id — yahi cart me jayega
    const formId = wrapper.getAttribute('data-form-id');
    const form = (formId && document.getElementById(formId)) || (card && card.querySelector('form'));
    const idInput = form && form.querySelector('input[name="id"]');
    if (idInput) idInput.value = pill.dataset.variantId;
    if (card) card.setAttribute('product-id', pill.dataset.variantId);

    // price block update (theme ke price snippet ke classes)
    const priceBox = card && card.querySelector('[card-price-container]');
    if (priceBox) {
      const priceEl = priceBox.querySelector('.price');
      if (priceEl) priceEl.textContent = pill.dataset.price || '';
      setText(priceBox.querySelector('.original-price'), pill.dataset.compare);
      setText(priceBox.querySelector('.offer'), pill.dataset.off);
    }

    // variant ka apna image ho to swap
    if (pill.dataset.image && card) {
      const img = card.querySelector('.primary_image');
      if (img) {
        img.removeAttribute('srcset');
        img.src = pill.dataset.image;
      }
    }
  });
})();